export default class SearchService {
    public static getUriWithParam(baseUrl: string, params: Record<string, any>, pathName = true): string {
        const Url = new URL(baseUrl);
        const urlParams: URLSearchParams = new URLSearchParams(Url.search);
        for (const key in params) {
            if (params[key] !== undefined) {
                if (params[key] == null) {
                    urlParams.delete(key);
                } else {
                    urlParams.set(key, params[key]);
                }
            }
        }
        Url.search = urlParams.toString();
        return pathName ? Url.pathname + Url.search : Url.href;
    }
}
